import { Skeleton } from '../../../Skeleton'

import * as styles from './RequestProfileHeaderFooterSkeleton.module.css'

function RequestProfileHeaderFooterSkeleton({ elementRef }) {
  return (
    <div className={styles.footer} ref={elementRef}>
      <Skeleton className={styles.bar} />
    </div>
  )
}

export default RequestProfileHeaderFooterSkeleton
